import Button from "@/components/ui/Button";
import React, { useState } from "react";

interface Plan {
  name: string;
  price: string;
  campaigns: string;
  assets: string;
}

const plans: Plan[] = [
  {
    name: "Free Trial",
    price: "$0/mo",
    campaigns: "1 Campaign",
    assets: "Unlimited Assets",
  },
  {
    name: "Basic",
    price: "$XX/mo",
    campaigns: "15 Campaigns",
    assets: "Unlimited Assets",
  },
  {
    name: "Unlimited",
    price: "$XX/mo",
    campaigns: "Unlimited Campaigns",
    assets: "Unlimited Assets",
  },
];

const billingOptions = ["Yearly", "Monthly"];

interface Props {
  onNext: () => void;
}

const StepThreeMediaAgencyOnboarding: React.FC<Props> = ({ onNext }) => {
  const [selectedPlan, setSelectedPlan] = useState("Unlimited");
  const [billing, setBilling] = useState("Yearly");

  return (
    <div className="min-h-screen flex flex-col items-center pt-1">
      <div className="w-full max-w-5xl bg-white p-10 flex flex-col items-center gap-5">
        {/* Header */}
        <header className="mb-8">
          <h1 className="text-3xl font-extrabold text-[#EA33C0] text-center">
            MediaBridge
          </h1>
          <p className="text-center font-semibold mt-10 text-xl">
            Awesome, almost done.
            <br />
            Which subscription plan suits you best?
          </p>
        </header>

        {/* Plans */}
        <div className="flex gap-8 justify-center w-full max-w-4xl">
          {plans.map(({ name, price, campaigns, assets }) => {
            const isSelected = selectedPlan === name;
            return (
              <button
                key={name}
                className={`flex flex-col border rounded-lg p-5 w-40 cursor-pointer transition-colors duration-300 text-center
              ${
                isSelected
                  ? "border-[#EA33C0]"
                  : "border-gray-300 hover:border-[#EA33C0]"
              }`}
                onClick={() => setSelectedPlan(name)}
              >
                <h2 className="text-lg font-normal">{name}</h2>
                <span className="text-gray-500 text-xs mt-1 mb-4 border-b border-gray-200 pb-2">
                  {price}
                </span>
                <span className="text-sm">{campaigns}</span>
                <span className="text-sm">{assets}</span>
              </button>
            );
          })}
        </div>

        {/* Billing frequency */}
        <div className="flex flex-col items-center w-full max-w-md mt-10 gap-2">
          <label
            htmlFor="billingFreq"
            className="text-xs font-semibold text-center"
          >
            How often would you like to be billed?
          </label>
          <select
            id="billingFreq"
            value={billing}
            onChange={(e) => setBilling(e.target.value)}
            className="w-full border border-[#EA33C0] rounded-md px-4 py-2 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#EA33C0]"
          >
            {billingOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {/* Select plan button */}
        <div className="mt-8">
          <Button type="primary" onClick={onNext}>
            Create Account
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StepThreeMediaAgencyOnboarding;
